import { PagePerformedByRequestDTO } from './page-performed-by-request-dto';

export interface ReadUserApproverRoleRequestDTO extends PagePerformedByRequestDTO {
    languageCd?: string;
}
